import { render, staticRenderFns } from "./TransferHolds.vue?vue&type=template&id=05f66946"
import script from "./TransferHolds.vue?vue&type=script&lang=js"
export * from "./TransferHolds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports